import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncAppleMusicToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncAppleMusicToAppleMusic}
            sections={<PairSyncGuideContent sourceKey="appleMusic" destKey="appleMusic" />}
        />
    );
}
